import React from "react";
import "../printStyles.css";

function MaintenanceSchedule() {
  return (
    <>
      {/* CSS for print functionality to hide everything but the form */}
      <style>
        {`
          @media print {
            body * { visibility: hidden; }
            #MaintenanceSchedule, #MaintenanceSchedule * { visibility: visible; }
            #MaintenanceSchedule {
              position: absolute;
              left: 0; top: 0;
              width: 100%;
              margin: 0; padding: 0;
              box-shadow: none; border: none;
            }
            @page { size: A4 landscape; margin: 10mm; }
            .print-button { display: none; }
          }
          /* Tight table for landscape printing */
          #MaintenanceSchedule table { border-collapse: collapse; width: 100%; table-layout: fixed; }
          #MaintenanceSchedule th, #MaintenanceSchedule td { border: 1px solid #000; padding: 4px; font-size: 11px; word-wrap: break-word; }
          #MaintenanceSchedule th { background: #f7f7f7; }
        `}
      </style>

      <div id="MaintenanceSchedule" className="p-4 border rounded-lg bg-white shadow-md font-sans">
        <h3 className="text-2xl font-semibold mb-2 text-gray-800">Maintenance Schedule</h3>

        {/* Header fields */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3">
          <div>
            <label className="block text-sm font-medium">Operator / Company</label>
            <input className="p-2 border rounded w-full" placeholder="Company Name" />
          </div>
          <div>
            <label className="block text-sm font-medium">Depot / Operating Centre</label>
            <input className="p-2 border rounded w-full" placeholder="Depot / OC" />
          </div>
          <div>
            <label className="block text-sm font-medium">Prepared By / Date</label>
            <div className="grid grid-cols-2 gap-2">
              <input className="p-2 border rounded w-full" placeholder="Name" />
              <input type="date" className="p-2 border rounded w-full" />
            </div>
          </div>
        </div>

        {/* Planner Table */}
        <table className="mb-4">
          <thead>
            <tr>
              <th style={{ width: '90px' }}>VRN</th>
              <th style={{ width: '60px' }}>Fleet #</th>
              <th style={{ width: '80px' }}>Type</th>
              <th style={{ width: '60px' }}>PMI (wks)</th>
              <th style={{ width: '90px' }}>Next PMI</th>
              <th style={{ width: '90px' }}>MOT Due</th>
              <th style={{ width: '100px' }}>Tacho Cal Due</th>
              <th style={{ width: '90px' }}>Tax Due</th>
              <th style={{ width: '100px' }}>Insurance Expiry</th>
              <th style={{ width: '100px' }}>Last Brake Test</th>
              <th style={{ width: '100px' }}>Next Brake Test</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 10 }).map((_, i) => (
              <tr key={i}>
                <td><input className="p-2 border rounded w-full" placeholder="AB12 CDE" /></td>
                <td><input className="p-2 border rounded w-full" placeholder="123" /></td>
                <td><input className="p-2 border rounded w-full" placeholder="HGV / PSV / Van / Trailer" /></td>
                <td><input className="p-2 border rounded w-full" placeholder="6" /></td>
                <td><input type="date" className="p-2 border rounded w-full" /></td>
                <td><input type="date" className="p-2 border rounded w-full" /></td>
                <td><input type="date" className="p-2 border rounded w-full" /></td>
                <td><input type="date" className="p-2 border rounded w-full" /></td>
                <td><input type="date" className="p-2 border rounded w-full" /></td>
                <td><input type="date" className="p-2 border rounded w-full" /></td>
                <td><input type="date" className="p-2 border rounded w-full" /></td>
                <td><input className="p-2 border rounded w-full" placeholder="Tyres/repairs/PMI notes" /></td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Footer note */}
        <p className="text-xs text-gray-700 mb-3">
          Tip: Align PMI, brake tests and MOT prep to minimise downtime. Keep copies with your maintenance records for DVSA inspection readiness This Schedule is for emergency or record keeping purposes ONLY.
        </p>

        {/* Print Button */}
        <div className="mb-2 text-right">
          <button
            type="button"
            onClick={() => window.print()}
            className="w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors print-button"
          >
            Print Schedule
          </button>
        </div>
      </div>
    </>
  );
}

export default MaintenanceSchedule;